import { render } from "./EventList.vue?vue&type=template&id=a695fb48&scoped=true"
import script from "./EventList.vue?vue&type=script&lang=js"
export * from "./EventList.vue?vue&type=script&lang=js"

import "./EventList.vue?vue&type=style&index=0&id=a695fb48&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a695fb48"

export default script